// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ip3x7NaNv81wutWZ{border-radius:1000px}.UMjP5YjuqOASOovg{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.A6Uz0oTHmsvUWIyW{display:flex;flex-direction:column;justify-content:center;align-items:center}.F2RjBtdxdwWyEtSR{animation:LFsU498_154DH2t_ 3s infinite;animation-iteration-count:infinite}@keyframes LFsU498_154DH2t_{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.SF7oNG75KfEAvSxf:not(.AuRFv4LQ7oN6QOOg){cursor:pointer;color:#1676b0}.SF7oNG75KfEAvSxf:not(.AuRFv4LQ7oN6QOOg):hover{text-decoration:underline}.SF7oNG75KfEAvSxf:not(.AuRFv4LQ7oN6QOOg).piRWwsFB2Ul5g7UV{text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `Ip3x7NaNv81wutWZ`,
	"text-truncate": `UMjP5YjuqOASOovg`,
	"shaquille": `A6Uz0oTHmsvUWIyW`,
	"shimmer": `F2RjBtdxdwWyEtSR`,
	"placeHolderShimmer": `LFsU498_154DH2t_`,
	"link": `SF7oNG75KfEAvSxf`,
	"overrideStyles": `AuRFv4LQ7oN6QOOg`,
	"noUnderline": `piRWwsFB2Ul5g7UV`
};
export default ___CSS_LOADER_EXPORT___;
